<template>
  <div>
    <div class="my-3">
      Regardless of whether you’d like to use your main number for texting or get a new number, you must first complete this setup process and get a number assigned.
    </div>
    <div class="my-3">
      Enter either an Area Code or Zip Code you would like the phone number in, and we will assign you an available number.
    </div>
    <v-row class="align-center">
      <v-col class="col-auto">
        <v-text-field
          v-model="sync_areaCode"
          dense
          label="Area Code"
          mask="###"
          :rules="[ validateArea ]"
        />
      </v-col>

      <v-col class="col-auto">
        OR
      </v-col>

      <v-col class="col-auto">
        <v-text-field
          v-model="sync_zipCode"
          dense
          label="ZIP Code"
          mask="#####"
          :rules="[ validateZip ]"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TSPhoneLookup',
  props: {
    zipCode: {
      type: String,
      required: true
    },
    areaCode: {
      type: String,
      required: true
    }
  },
  computed: {
    sync_areaCode: {
      get () {
        return this.areaCode;
      },
      set (v) {
        this.$emit('update:areaCode', v);
      }
    },
    sync_zipCode: {
      get () {
        return this.zipCode;
      },
      set (v) {
        this.$emit('update:zipCode', v);
      }
    }
  },
  methods: {
    validateArea () {
      var areaCodeRegex = /^\d{3}$/;
      if ((this.areaCode || null) === null || this.areaCode === '') return true;

      // Check area code format
      if (areaCodeRegex.test(this.areaCode)) {
        this.$emit('error', false);
        return true;
      }
      this.$emit('error', true);
      return 'Area Code must be a three digit number';
    },
    validateZip () {
      var zipCodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;

      if ((this.zipCode || null) === null || this.zipCode.trim() === '') {
        this.$emit('error', false);
        return true;
      }

      // Check zip code format
      if (zipCodeRegex.test(this.zipCode)) {
        this.$emit('error', false);
        return true;
      }

      this.$emit('error', true);
      return 'ZIP Code must be a five digit number';
    }
  }
};
</script>
